import './App.css';
import Creditcard from './components/Creditcard';
import Cheque from './components/Cheque';
import { useState, useEffect } from 'react';
import config from "./config/config";
import axios from 'axios';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import DenialPage from './components/DenialPage';
import ThankYouPage from './components/ThankyouPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {

  const [value, setValue] = useState(0);
  const [selecteditem,setSelecteditem] = useState(0);
  const [isValid, setIsValid] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [uuid, setUuid] = useState('');
  const [useremail,Setuseremail]= useState('');
  const [companyname,Setcompanyname]= useState('');
  const [data,setData] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  
  
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const jwtData = queryParams.get('data');
   
    if (!jwtData) {
      setErrorMessage('No token data found.');
      setLoading(false);
      return;
    }
    setData(jwtData);
    validateJwt(jwtData);
  }, [location]);

  const validateJwt = async (jwtData) => {
    try {
      const response = await axios.post(`${config.API_BASE_URL}/api/validate_url`, { data: jwtData });
      if (response.status === 200) {
        setIsValid(true);
        // console.log(response);
        setUuid(response.data.uuid);
        Setuseremail(response.data.user_email);
        Setcompanyname(response.data.comp_name);
        setLoading(false);
      }
    } catch (error) {
      setIsValid(false);
      setErrorMessage(error.response?.data?.error || 'An error occurred');
      setLoading(false);
    }
  };
  if (loading && location.pathname !== "/thank-you") {
    return <div></div>;
  }
  
  if (!isValid && location.pathname !== "/thank-you") {
    return <DenialPage />;
  }
  const handleChange = (e) => {
    setSelecteditem(e.target.value);
  };
  const handleSubmit = async () => {
    const isAuthorized = document.getElementById("authorized").checked; // Check if the checkbox is checked
    if (isAuthorized) {
       if(selecteditem == 0){
        alert("Please choose a payment method !");
       }else{
        setValue(selecteditem); // Set the value if checkbox is checked
       }
    } else {
        alert("Please agree to the terms and conditions!"); // Show an alert if not checked
    }
  };

  return (
    <Routes>
      <Route
        path="/doc_scanner"
        element={
          <>
            {value === 0 ? (
              <>
              <Navbar/>
            <div className="homecont container container-50 main-content">
              <div className='row'>
              <div className='col-12'>
              <div className='paymentmethod card'>
                 <div className='card-header title'><h5 className='mb-0 py-1' style={{overflow: "hidden"}}>Choose a payment method </h5></div>
                 <div className='card-body'>
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "12px",
                  marginBottom: "8px",
                }}
              >
                <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="1"
                    onChange={handleChange}
                    style={{ marginRight: "12px" }}
                  />
                  <div>
                    <b>Credit or debit card</b>
                    <p style={{ margin: "0", fontSize: "12px", color: "#555" }}>
                      All major credit card can be scanned.
                    </p>
                  </div>
                </label>
              </div>
        
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "12px",
                }}
              >
                <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="2"
                    onChange={handleChange}
                    style={{ marginRight: "12px" }}
                  />
                  <div>
                    <b>Check</b>
                    <p style={{ margin: "0", fontSize: "12px", color: "#555" }}>
                      Checks from major backs can be scanned
                    </p>
                  </div>
                </label>
              </div>
            </div>
            </div>
            
            <div className="authorization card mt-4" >
              <div className='card-body'>
            <input style={{marginRight:"10px"}} type="checkbox" name="authorized" id="authorized" />
                <span className='ml-3' style={{textAlign:"left"}}>
                    I authorize <strong>company_Name</strong> to charge the banking details/Card Details as provided here. 
                    I understand that this authorization will remain in effect until I cancel it in writing. I agree to notify 
                    the merchant in writing of any changes to my account information or the termination of this authorization 
                    at least 15 days prior to the billing date. In case of any ACH or card payments being rejected, an additional fee, 
                    as applicable, will apply.
                </span>
          </div>
          </div>
          <div className='mt-4'>
                <button className="btn btn-xl w-100 btn-primary saveinfo" onClick={handleSubmit}>Submit</button>
          </div>  
          </div>
          </div>
          </div>      
          <Footer/>
        </>
            ) : (
              ""
            )}
            {value == 2 ? <Cheque uuid={uuid} user_email={useremail} company_name={companyname} /> : ""}
            {value == 1 ? <Creditcard uuid={uuid} user_email={useremail} company_name={companyname} /> : ""}
          </>
        }
      />
      <Route path="/thank-you" element={<ThankYouPage />} />
    </Routes>
  );
}

export default App;
